export default function getDomainSuffix(): string {
  return (
    (typeof window !== "undefined"
      ? window.location.hostname
          .split(".")
          .slice(1)
          .filter(part => part !== "beta")
          .join(".")
      : "") ||
    import.meta.env.VITE_LOCAL_DOMAIN_SUFFIX ||
    "development.neonumy.dev"
  );
}
